<app-page-header [breadcrumbs]="breadcrumbs" [description]="description" [heading]="heading"></app-page-header>
<section>
  <div class="container">
    <div [data]="markdown" class="article" clipboard lineNumbers markdown mermaid></div>
  </div>
</section>

<section class="other-articles" *ngIf="otherArticles.length > 0">
  <div class="container">
    <h3>Other Articles</h3>
    <div class="grid-box3">
      <div *ngFor="let a of otherArticles" class="grid-item">
        <a [routerLink]="['/blog/article', a.slug.S]" class="other-article-card">
          <div class="cnt-box cnt-box-info boxed">
            <div class="img-box">
              <img [src]="a.thumbnail.S" [alt]="a.title.S">
            </div>
            <div class="caption">
              <h2>{{a.title.S}}</h2>
              <p>{{a.description.S}}</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- 💡 Add a visual break and CTA header -->
<section class="contact-callout">
  <h3 class="text-center text-primary">
    Let's Work Together
  </h3>
</section>

<app-section-contact class="compact-contact"></app-section-contact>
